<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const PRODUCT_PROMOTION_CLICK = analyticsUtilities.events.PRODUCT_PROMOTION_CLICK;

	module.exports = {
		components: {
			'article-image': require('components/article-image.vue').default
		},
		props: {
			applyFilters: {
				default: function () {
					return;
				}
			},
			featuredTopics: {
				default: []
			}
		},
		methods: {
			onTopicClick(topic) {
				let id = topic.id;
				let loc = 'FEATURED_TOPIC';
				fireEvent(PRODUCT_PROMOTION_CLICK, {
					id,
					loc
				});
				this.applyFilters(topic);
			}
		}
	};
</script>
<template>
	<div class="promotion-panel featured-topics">
		<h2
			class="has-sub-heading"
			id="featured-topic-heading">
			Explore by Topic
		</h2>
		<div class="sub-heading">What to teach today</div>
		<ul
			class="featured-topic-row"
			aria-labelledby="featured-topic-heading">
			<li
				v-for="topic in featuredTopics"
				:key="topic.name">
				<a
					class="featured-topic"
					href="javascript:void(0)"
					@click="onTopicClick(topic)">
					<article-image :image-url="topic.thumb"></article-image>
					<div class="featured-topic-name">{{ topic.name }}</div>
				</a>
			</li>
		</ul>
	</div>
</template>
